import * as t from "./types";
import * as actions from "./action";

/* Team */
export const getTeamAction = (
  payload: t.GetTeamRequestType
): t.GetTeamActionType => {
  return {
    type: actions.GET_TEAM,
    payload,
  };
};

export const getTeamsAction = (
  payload: t.GetTeamsRequestType
): t.GetTeamsActionType => {
  return {
    type: actions.GET_TEAMS,
    payload,
  };
};

export const addTeamAction = (
  payload: t.CreateTeamRequestType
): t.AddTeamActionType => {
  return {
    type: actions.ADD_TEAM,
    payload,
  };
};

export const modifyTeamAction = (
  payload: t.ModifyTeamRequestType
): t.ModifyTeamActionType => {
  return {
    type: actions.MODIFY_TEAM,
    payload,
  };
};

export const deleteTeamAction = (
  payload: t.DeleteTeamRequestType
): t.DeleteTeamActionType => {
  return {
    type: actions.DELETE_TEAM,
    payload,
  };
};

/* Team User */
export const getTeamUserAction = (
  payload: t.GetTeamsUserRequestType
): t.GetTeamUserActionType => {
  return {
    type: actions.GET_TEAM_USER,
    payload,
  };
};

export const getTeamUsersAction = (
  payload: t.GetTeamUsersRequestType
): t.GetTeamUsersActionType => {
  return {
    type: actions.GET_TEAM_USERS,
    payload,
  };
};

export const addTeamUserAction = (
  payload: t.AddTeamUserRequestType
): t.AddTeamUserActionType => {
  return {
    type: actions.ADD_TEAM_USER,
    payload,
  };
};

export const deleteTeamUserAction = (
  payload: t.RemoveTeamUserRequestType
): t.DeleteTeamUserActionType => {
  return {
    type: actions.DELETE_TEAM_USER,
    payload,
  };
};
